import React from "react";
import classes from "./HeaderTitle.module.css";
import ciciIcon from "../../../../Images/header-cici-icon.svg";
import { translations } from "../../../../Components/AffordabilityToolWizard/translations";
import { useLanguage } from "../../../../UiKit/Wizard/langugeContext";
import useChatbot from "../../../../Hooks/useChatbot";
import liveChatHearder from "../../../../Images/liveChatHeader.svg";

function HeaderTitle() {
  const { currentLanguage } = useLanguage();
  const { isLiveChatActive } = useChatbot();

 
  const welcomeTranslations = translations[currentLanguage].VirtualAssistant;


  //console.log("isLiveChatActive", isLiveChatActive);
  const iconSrc = isLiveChatActive ? liveChatHearder : ciciIcon;
  const titleText = isLiveChatActive
    ? welcomeTranslations.LiveChat
    : welcomeTranslations.VirtualAssistant;

  return (
    <div className={classes["header-title"]}>
      <img
        src={iconSrc}
        alt="Cici"
        style={isLiveChatActive ? { marginBottom: "-4px" } : {}}
      />
      <div className={classes["header-title__text"]}>
        {titleText}
      </div>
    </div>
  );
}

export default HeaderTitle;
